<header class="rental__header">
  <img class="rental__header__logo" src="images/logos/sodimac-header.svg" alt="SODIMAC"/>

  @if (pwaService.canInstallApp()) {
    <button (click)="pwaService.installApp()" mat-raised-button color="primary" class="rental__header__button">
      ¡Instalar App!
    </button>
  }
</header>

